import { render, staticRenderFns } from "./PublicPanel.vue?vue&type=template&id=0f857e2f&scoped=true&"
import script from "./PublicPanel.vue?vue&type=script&lang=js&"
export * from "./PublicPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f857e2f",
  null
  
)

export default component.exports